import React, { useState } from 'react';
import AppSnackbar from '../../../common/AppSnackbar';

import HeaderTitleEdit from '../../../common/HeaderTitleEdit';
import HazardRenameDialog from '../dialogs/HazardRenameDialog';
import { Hazard } from '../Hazard.interface';

export interface HazardHeaderTitleProps {
  children?: React.ReactNode;
  hazard: Hazard | undefined;
  disabled?: boolean;
  onChange?: (product: Partial<Hazard>) => void;
}

const HazardHeaderTitle: React.FC<HazardHeaderTitleProps> = (
  props: HazardHeaderTitleProps
) => {
  const { disabled, children, hazard, onChange } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [didUpdate, setDidUpdate] = useState<boolean>(false);

  return (
    <>
      <HeaderTitleEdit
        children={children}
        disabled={disabled || !hazard}
        onClick={() => setOpen(true)}
      />
      {hazard && (
        <HazardRenameDialog
          open={open}
          hazard={hazard}
          onChange={onChange}
          onCancel={() => setOpen(false)}
          onUpdate={() => {
            setOpen(false);
            setDidUpdate(true);
          }}
        />
      )}
      <AppSnackbar
        open={didUpdate}
        severity='success'
        onClose={() => setDidUpdate(false)}
      >
        Hazard name updated.
      </AppSnackbar>
    </>
  );
};

export default HazardHeaderTitle;
